export default __webpack_public_path__ + "static/feature-no-reminders-e169099618908e492e22a3943cba4c98.png";